import { connect } from 'react-redux'

import { IRootState } from '../../../common/reducers'
import UsDollarsNotice from './usDollarsNotice'

interface IStateProps {
  notice: string | null
}

interface IOwnProps {
  styleClassName?: string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { user: { usDollarsNotice } } = state

  return { notice: usDollarsNotice }
}

const UsDollarsNoticeContainer = connect<
  IStateProps,
  {},
  IOwnProps,
  IRootState
>(mapStateToProps)(UsDollarsNotice)

export default UsDollarsNoticeContainer
